var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "a-row",
        { attrs: { type: "flex", justify: "center" } },
        [
          _c(
            "vxe-button",
            {
              attrs: { size: "mini", status: "primary" },
              on: {
                click: function ($event) {
                  return _vm.print()
                },
              },
            },
            [_vm._v(" 打印 ")]
          ),
        ],
        1
      ),
      _c(
        "a-row",
        {
          ref: "printArea",
          staticStyle: { "padding-top": "100px" },
          attrs: { type: "flex", justify: "center", align: "middle" },
        },
        [
          _c(
            "table",
            { attrs: { border: "1", cellspacing: "0", cellpadding: "0" } },
            [
              _c("tr", [
                _c(
                  "th",
                  { staticClass: "table-name", attrs: { colspan: "7" } },
                  [_vm._v("客户信息档案表")]
                ),
              ]),
              _c("tr", [
                _c("th", { staticClass: "td3", attrs: { rowspan: "3" } }, [
                  _vm._v("车辆信息"),
                ]),
                _c("td", { staticClass: "td1", attrs: { colspan: "1" } }, [
                  _vm._v("品系"),
                ]),
                _c("td", { staticClass: "td2", attrs: { colspan: "2" } }, [
                  _vm._v(_vm._s(_vm.entityForm.strainName)),
                ]),
                _c("td", { staticClass: "td1", attrs: { colspan: "1" } }, [
                  _vm._v("购车时间"),
                ]),
                _c("td", { staticClass: "td2", attrs: { colspan: "2" } }, [
                  _vm._v(_vm._s(_vm.entityForm.e3sDeliveryDate)),
                ]),
              ]),
              _c("tr", [
                _c("td", { staticClass: "td1", attrs: { colspan: "1" } }, [
                  _vm._v("底盘号"),
                ]),
                _c("td", { staticClass: "td2", attrs: { colspan: "2" } }, [
                  _vm._v(_vm._s(_vm.entityForm.batholithNo)),
                ]),
                _c("td", { staticClass: "td1", attrs: { colspan: "1" } }, [
                  _vm._v("车型代码"),
                ]),
                _c("td", { staticClass: "td2", attrs: { colspan: "2" } }, [
                  _vm._v(_vm._s(_vm.entityForm.modelCode)),
                ]),
              ]),
              _c("tr", [
                _c("td", { staticClass: "td1", attrs: { colspan: "1" } }, [
                  _vm._v("所属经理部"),
                ]),
                _c("td", { staticClass: "td2", attrs: { colspan: "2" } }, [
                  _vm._v(_vm._s(_vm.entityForm.regionName)),
                ]),
                _c("td", { staticClass: "td1", attrs: { colspan: "1" } }, [
                  _vm._v("经销商"),
                ]),
                _c("td", { staticClass: "td2", attrs: { colspan: "2" } }, [
                  _vm._v(_vm._s(_vm.entityForm.dealerName)),
                ]),
              ]),
              _c("tr", [
                _c("th", { staticClass: "td3", attrs: { rowspan: "7" } }, [
                  _vm._v("客户信息"),
                ]),
                _c("td", { staticClass: "td1", attrs: { colspan: "1" } }, [
                  _vm._v("姓名"),
                ]),
                _c("td", { staticClass: "td2", attrs: { colspan: "2" } }, [
                  _vm._v(_vm._s(_vm.entityForm.custName)),
                ]),
                _c("td", { staticClass: "td1", attrs: { colspan: "1" } }, [
                  _vm._v("性别"),
                ]),
                _c("td", { staticClass: "td2", attrs: { colspan: "2" } }, [
                  _vm._v(_vm._s(_vm.entityForm.sexName)),
                ]),
              ]),
              _c("tr", [
                _c("td", { staticClass: "td1", attrs: { colspan: "1" } }, [
                  _vm._v("电话"),
                ]),
                _c("td", { staticClass: "td2", attrs: { colspan: "2" } }, [
                  _vm._v(_vm._s(_vm.entityForm.mobile)),
                ]),
                _c("td", { staticClass: "td1", attrs: { colspan: "1" } }, [
                  _vm._v("民族"),
                ]),
                _c("td", { staticClass: "td2", attrs: { colspan: "2" } }, [
                  _vm._v(_vm._s(_vm.entityForm.nationName)),
                ]),
              ]),
              _c("tr", [
                _c("td", { staticClass: "td1", attrs: { colspan: "1" } }, [
                  _vm._v("身份证"),
                ]),
                _c("td", { staticClass: "td2", attrs: { colspan: "2" } }, [
                  _vm._v(_vm._s(_vm.entityForm.idCard)),
                ]),
                _c("td", { staticClass: "td1", attrs: { colspan: "1" } }, [
                  _vm._v("出生日期"),
                ]),
                _c("td", { staticClass: "td2", attrs: { colspan: "2" } }, [
                  _vm._v(_vm._s(_vm.entityForm.birthday)),
                ]),
              ]),
              _c("tr", [
                _c("td", { staticClass: "td1", attrs: { colspan: "1" } }, [
                  _vm._v("行业"),
                ]),
                _c("td", { staticClass: "td2", attrs: { colspan: "2" } }, [
                  _vm._v(_vm._s(_vm.entityForm.industryName)),
                ]),
                _c("td", { staticClass: "td1", attrs: { colspan: "1" } }, [
                  _vm._v("客户类型"),
                ]),
                _c("td", { staticClass: "td2", attrs: { colspan: "2" } }, [
                  _vm._v(_vm._s(_vm.entityForm.custCategoryName)),
                ]),
              ]),
              _c("tr", [
                _c("td", { staticClass: "td1", attrs: { colspan: "1" } }, [
                  _vm._v("是否乘龙老友"),
                ]),
                _c("td", { staticClass: "td2", attrs: { colspan: "2" } }, [
                  _vm._v(_vm._s(_vm.entityForm.isOldFriendName)),
                ]),
                _c("td", { staticClass: "td1", attrs: { colspan: "1" } }, [
                  _vm._v("职位"),
                ]),
                _c("td", { staticClass: "td2", attrs: { colspan: "2" } }),
              ]),
              _c("tr", [
                _c("td", { staticClass: "td1", attrs: { colspan: "1" } }, [
                  _vm._v("省份"),
                ]),
                _c("td", { staticClass: "td2", attrs: { colspan: "2" } }, [
                  _vm._v(_vm._s(_vm.entityForm.provinceName)),
                ]),
                _c("td", { staticClass: "td1", attrs: { colspan: "1" } }, [
                  _vm._v("市"),
                ]),
                _c("td", { staticClass: "td2", attrs: { colspan: "2" } }, [
                  _vm._v(_vm._s(_vm.entityForm.cityName)),
                ]),
              ]),
              _c("tr", [
                _c("td", { staticClass: "td1", attrs: { colspan: "1" } }, [
                  _vm._v("区"),
                ]),
                _c("td", { staticClass: "td2", attrs: { colspan: "2" } }, [
                  _vm._v(_vm._s(_vm.entityForm.districtName)),
                ]),
                _c("td", { staticClass: "td1", attrs: { colspan: "1" } }, [
                  _vm._v("详细地址"),
                ]),
                _c(
                  "td",
                  {
                    staticClass: "td2",
                    staticStyle: {
                      "text-align": "left",
                      "padding-left": "10px",
                    },
                    attrs: { colspan: "2" },
                  },
                  [_vm._v(_vm._s(_vm.entityForm.address))]
                ),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }